<template>
    <div>
        <div class="register__section">

            <div class="register__wrapper">
                <h2 class="register__heading h1" v-translate>registration_step_3_title</h2>
                <div class="register__intro" v-translate>registration_step_3_intro</div>
            </div>

            <div class="register__frequency form">
                <div class="register__frequency__row">
                    <div class="register__frequency__text" v-translate>registration_step_3_i_workout</div>
                    <div class="register__frequency__field">
                        <div class="form__item">
                            <v-select 
                                class="form__v-select" 
                                v-model="registrationUser.preferences.workoutInterval" 
                                :options="intervalOptions" 
                                :clearable="false"
                            ></v-select>
                        </div>
                    </div>
                    <div class="register__frequency__text" v-translate>registration_step_3_times_per_week</div>
                </div>
                <div class="register__frequency__row">
                    <div class="register__frequency__text" v-translate>registration_step_3_usually_at</div>
                    <div class="register__frequency__field">
                        <div class="form__item">
                            <v-select 
                                class="form__v-select" 
                                v-model="registrationUser.preferences.workoutTimeOfDay" 
                                :options="timeOfDayOptions" 
                                :clearable="false"
                            ></v-select>
                        </div>
                    </div>
                    <div class="register__frequency__text" v-translate>registration_step_3_for_about</div>
                    <div class="register__frequency__field">
                        <div class="form__item">
                            <v-select 
                                class="form__v-select" 
                                v-model="registrationUser.preferences.workoutDuration" 
                                :options="durationOptions" 
                                :reduce="item => item.code"
                                :clearable="false"
                            ></v-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    props: {
  
    },
    computed: {
        ...mapState({
            'registrationUser': 'registrationUser'
        }),
    },
    data() {
        return {
            intervalOptions: [1, 2, 3, 4, 5, 6, 7],
            timeOfDayOptions: this.getTimeOfDayOptions(),
            durationOptions: this.getDurationOptions()
        }
    },
    created() {

    },
    methods: {
        getTimeOfDayOptions() {
            let options = [];
            for (let hour = 0; hour < 24; hour++) {
                for (let min = 0; min < 4; min++) {
                    options.push(`${(hour < 10 ? '0' : '')}${hour}:${min * 15}${min === 0 ? '0' : ''}`);
                }
            }
            return options;
        },
        getDurationOptions() {
            let options = [];
            for (let hour = 0; hour < 4; hour++) {
                for (let min = 0; min < 4; min++) {
                    let label = `${hour > 0 ? hour + this.$gettext('hour_abbr') : ''} ${min === 0 ? '0' : ''}${min * 15}${this.$gettext('min_abbr')}`;
                    let value = (hour * 60 * 60) + (min * 15 * 60);
                    if(value) {
                        options.push({label, code: value});
                    }
                }
            }
            return options;
        }
    }
}
</script>

<style lang="scss">
// styles in "RegistrationSteps" component
</style>
